
<template lang="pug">
    Aside(:ativo="ativo", label="Imagem ampliada", @close="ativo = false")#asideImage
        .content
            .img
                img(:src="image.image", :alt="image.alt || ''").image
            p(v-if="image.text" v-html="image.text")
            p.caption(v-if="image.caption") {{ image.caption }}
</template>

<script>
import Aside from '@components/Aside/Aside'

export default {
    name: "component-aside-image",
    components: {
        Aside,
    },
    computed: {
        ativo: {
            get() {
                return this.$store.state.imageModal.ativo
            },
            set(value) {
                this.$store.commit('setImage', { ativo: value, content: {} })
            }
        },
        image() {
            // return this.$store.state.imageModal.content
            return {
                ...this.$store.state.imageModal.content, 
                image: this.$store.state.imageModal.content.image
            }
        },
    },
}
</script>

<style lang="stylus" scoped src="./AsideImage.styl"></style>
